import React from "react";

const DirectorMessage = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800 ">
      {/* Photos Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[
          "../../../../assets/sfather.JPG",
          "../../../../assets/smother.JPG",
          "../../../../assets/sdoctor.JPG",
        ].map((photo) => (
          <div key={photo} className="text-center">
            <div className="w-full h-70 bg-gray-300 flex items-center justify-center rounded-md">
              {/* Replace with an <img> tag for real photos */}
              <img
                src={photo}
                alt={photo}
                className="w-full h-70 object-cover rounded-md"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Story Section */}
      <div className="bg-white p-6 rounded-md shadow-md">
        <h2 className="text-2xl font-bold mb-4">History, Mission & Vision</h2>
        <p className="mb-4">
          I am the proud son of dedicated and devoted parents, Late Shukdeo
          Yadav, a passionate school teacher, and Late Sumintra Devi, a loving
          homemaker. I was blessed with a large and supportive family, including
          two elder sisters, three younger sisters, and two younger brothers. My
          education journey took me through various institutions, starting from
          a village school to prestigious institutions such as Sainik School
          Tilaiya, Arya Samaj High School in Jamalpur, Munger, TNB College in
          Bhagalpur, Darbhanga Medical College in Laheriasarai, and Patna
          Medical College in Patna. These experiences enriched my life, exposed
          me to diverse challenges, and instilled resilience—most notably
          overcoming my failure at Sainik School Tilaiya.
        </p>
        <p className="mb-4">
          "Education is the right of every child, and every child can achieve
          the highest degree of knowledge if provided with proper guidance and
          opportunities." This belief was reaffirmed during my participation in
          the BAL MELA organized by BGVS at Paura Village near Kadirganj,
          Nawada, in 1993–94.
        </p>
        <p className="mb-4">
          In 1998, I collaborated with like-minded individuals to form{" "}
          <strong>Budhijivi Vichar Manch</strong>, an initiative aimed at
          uplifting the educational status of the underprivileged and
          educationally backward communities in Nawada district. To achieve
          this, we organized awareness campaigns, including evening meetings and{" "}
          <em>prabhat pheris</em> (early morning awareness drives) across
          villages and neighborhoods in the district.
        </p>
        <p className="mb-4">
          Recognizing the need for a space where children of all castes,
          religions, and socioeconomic statuses could learn together in harmony,
          I founded <strong>Shukdeo-Sumintra Foundation</strong> in 2017. This
          foundation, named in honor of my parents, was established with the
          support of family and friends, including Prof. Surender Kumar
          Jayaswal, Prof. Baldev Yadav, Q.S.A. Labib (Romiji), my schoolmate and
          lawyer Shambhu Lal, my wife Sudha Rani, and my daughter-in-law Jyoti
          Ray.
        </p>
        <p>
          The foundation's first major endeavor was the establishment of{" "}
          <strong>Shree Krishna Academy</strong> in the village of Teyar,
          Nawada. The academy aspires to nurture each child to embody at least
          one quality of Lord Krishna, enabling them to lead a meaningful and
          accomplished life.
        </p>
        <div className="text-right mt-6">
          <p className="font-bold">Dr. Suniti Kumar</p>
          <p>M.B.B.S, M.D.</p>
        </div>
      </div>
    </div>
  );
};

export default DirectorMessage;
